/*
Dentist Edit Profile Form Component
================================================================================
*/

/*
Imports
------------------------------------------------------------
*/
// libs
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {
  Field,
  reduxForm
} from 'redux-form';

// app
import Input from 'components/Input';
import LabeledInput from 'components/LabeledInput';
import InputGroup from 'components/InputGroup';
// images deletion actions

// local
import styles from '../styles.module.css';
import validator from '../validator';

/*
Field Validators
------------------------------------------------------------
*/

/*
Edit Profile Form
================================================================================
*/

@reduxForm({
  form: 'out-of-network-tab3',
  enableReinitialize:true,
  validate: validator,
})
@CSSModules(styles, { allowMultiple: true })
export default class Tab3 extends React.Component {

  constructor (props) {
    super(props);
    this.submitRef = React.createRef();
  }

  /*
  Actions
  ------------------------------------------------------------
  */



  getInput(props) {
    return new Input(props);
  }

  getLabeledInput(props) {
    return new LabeledInput(props);
  }


  getInputGroup(props) {
    return new InputGroup(props);
  }

  handleFormSubmit=(values)=>{
    this.props.changeOverhead(values)
  }

  handleKeyDown = (e) => {
    if(e.key == "Enter") {
      e.preventDefault();
      this.submitRef.current.click()
    }
  }
  /*
  Render
  ------------------------------------------------------------
  */
  render() {
    const {
        handleSubmit,
        submitting
      } = this.props;

    return (
      <form className="form-horizontal">
      <div className="container" styleName="tab3">
        <div styleName="introtext">
          <p>Now let’s look at your costs.</p>
          <p>We’re not going to worry with fixed costs like rent and utilities - those aren’t going anywhere regardless of the decision you make here.</p>
          <p>Note: if you calculate your doctor costs separately, enter them below. If not, leave the field blank.</p>
        </div>

        <div styleName="calculations" className="row" onKeyDown={this.handleKeyDown.bind(this)}>
          <span>Cost per visit:</span>

          <div styleName="ucr">
            <div className="col-sm-6 text-right">Hygenist</div>
            <Field type="number"
                name="hygenist"
                component={this.getInputGroup}
                leftAddon="$"
                label=""
              width={6}
              />
          </div>
          <div styleName="ucr">
            <div className="col-sm-6 text-right">Supplies </div>
            <Field type="number"
                component={this.getInputGroup}
                name="supplies"
                leftAddon="$"
                label=""
                width={6}
                />
          </div>
          <div styleName="ucr">
            <div className="col-sm-6 text-right">Doctor (if separate) </div>
               <Field type="number"
              component={this.getInputGroup}
              name="doctor"
              leftAddon="$"
              label="optional"
              width={6}
              />
            </div>
            <div styleName="ucr">
                <div className="col-sm-6 text-right">Miscellaneous </div>
                <Field type="number"
                  component={this.getInputGroup}
                  name="misc"
                  leftAddon="$"
                  label="optional"
                  width={6}
                  />
            </div>
          </div>

        <div styleName="nextbutton">
                    <a className="btn btn-primary" styleName="large-button--primary"  onClick={handleSubmit(this.handleFormSubmit)} ref={this.submitRef}>ENTER INSURANCE WRITE-OFFS {">"}</a>
                </div>
            </div>
      </form>
    );
  }
}
